import { InboundActionTypes } from './constants';

const GET_INBOUND_DATA_INITIAL_STATE = {
    inbound: [],
    loading: false,
};

const GET_EDIT_INBOUND_DATA_INITIAL_STATE = {
    editInbound: [],
    loading: false,
};
const GET_TAG_DATA_INITIAL_STATE = {
    tagNo: [],
    loading: false,
};

const GET_TAG_NO_INITIAL_STATE = {
    tagData: [],
    loading: false,
};

const CREATE_INBOUND_DATA_INITIAL_STATE = {
    createInbound: [],
    loading: false,
};

const UPLOAD_INBOUND_DATA_INITIAL_STATE = {
    uploadInbound: [],
    loading: false,
};

const UPDATE_INBOUND_DATA_INITIAL_STATE = {
    updateInbound: [],
    loading: false,
};
const DELETE_INBOUND_DATA_INITIAL_STATE = {
    deleteInboundData: [],
    loading: false,
};

const UPDATE_ALL_DATA_INITIAL_STATE = {
    updateAll: [],
    loading: false,
};

const UPDATE_ALL_YARDS_INITIAL_STATE = {
    updateYards: [],
    loading: false,
};
const UPDATE_SELECTED_DATA_INITIAL_STATE = {
    updateSelected: [],
    loading: false,
};
const UPDATE_SELECTED_UNIT_DATA_INITIAL_STATE = {
    updateSelectedUnit: [],
    loading: false,
};

const UPDATE_TRANSACTION_DATA_INITIAL_STATE = {
    updateTransaction: [],
    loading: false,
};
const GET_BY_TAG_INITIAL_STATE = {
    getByTag: [],
    loading: false,
};

const GET_BY_DOC_INITIAL_STATE = {
    getByDoc: [],
    loading: false,
};

const GET_PRINT_CONTENT_INITIAL_STATE = {
    getPrintContent: [],
    loading: false,
};
const GET_EXCEL_CONTENT_INITIAL_STATE = {
    getExcelContent: [],
    loading: false,
};
const UPDATE_TAG_BY_STATUS_INITIAL_STATE = {
    tagByStatus: [],
    loading: false,
};
const UPDATE_ALL_SELLING_PRICE_INITIAL_STATE = {
    updateAllSellingPrice: [],
    loading: false,
};

const UPDATE_DESCRIPTION_INITIAL_STATE = {
    description: [],
    loading: false
}
const UPDATE_ALL_UNITS_INITIAL_STATE = {
    units: [],
    loading: false
}

const GET_INVOICE_DATA_INITIAL_STATE = {
    invoiceData: [],
    loading: false
}

const GET_RECEIVER_DATA_INITIAL_STATE = {
    receiverData: [],
    loading: false
}
// ---------------------------------------------------------------I N  B O U N D--------------------------------------------------

const inboundReducer = (state = GET_INBOUND_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.INBOUND_DATA_LOADING:
            return {
                inbound: state.inbound,
                loading: true,
            };
        case InboundActionTypes.INBOUND_DATA_SUCCESS:
            return {
                inbound: action.payload,
                loading: false,
            };
        case InboundActionTypes.INBOUND_DATA_ERROR:
            return {
                inbound: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};

const getEditInboundReducer = (state = GET_EDIT_INBOUND_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.GET_EDIT_INBOUND_DATA_LOADING:
            return {
                editInbound: state.editInbound,
                loading: true,
            };
        case InboundActionTypes.GET_EDIT_INBOUND_DATA_SUCCESS:
            return {
                editInbound: action.payload,
                loading: false,
            };
        case InboundActionTypes.GET_EDIT_INBOUND_DATA_ERROR:
            return {
                editInbound: action.payload,
                loading: false,
            };
        case InboundActionTypes.GET_EDIT_INBOUND_DATA_RESET:
            return {
                editInbound: [],
                loading: false,
            };
        default:
            return state;
    }
};

const createInboundReducer = (state = CREATE_INBOUND_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.CREATE_INBOUND_DATA_LOADING:
            return {
                createInbound: state.createInbound,
                loading: true,
            };
        case InboundActionTypes.CREATE_INBOUND_DATA_SUCCESS:
            return {
                createInbound: action.payload,
                loading: false,
            };
        case InboundActionTypes.CREATE_INBOUND_DATA_ERROR:
            return {
                createInbound: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...CREATE_INBOUND_DATA_INITIAL_STATE };
        default:
            return state;
    }
};

const uploadInboundReducer = (state = UPLOAD_INBOUND_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPLOAD_INBOUND_DATA_LOADING:
            return {
                uploadInbound: state.uploadInbound,
                loading: true,
            };
        case InboundActionTypes.UPLOAD_INBOUND_DATA_SUCCESS:
            return {
                uploadInbound: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPLOAD_INBOUND_DATA_ERROR:
            return {
                uploadInbound: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPLOAD_INBOUND_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const updateInboundReducer = (state = UPDATE_INBOUND_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_INBOUND_DATA_LOADING:
            return {
                updateInbound: action.payload,
                loading: true,
            };
        case InboundActionTypes.UPDATE_INBOUND_DATA_SUCCESS:
            return {
                updateInbound: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_INBOUND_DATA_ERROR:
            return {
                updateInbound: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_INBOUND_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const updateAllReducer = (state = UPDATE_ALL_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_ALL_DATA_LOADING:
            return {
                updateAll: state?.updateAll,
                loading: true,
            };
        case InboundActionTypes.UPDATE_ALL_DATA_SUCCESS:
            return {
                updateAll: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_ALL_DATA_ERROR:
            return {
                updateAll: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_ALL_DATA_INITIAL_STATE };
        default:
            return state;
    }
};

const updateAllSellingPriceReducer = (state = UPDATE_ALL_SELLING_PRICE_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_ALL_SELLING_PRICE_LOADING:
            return {
                updateAllSellingPrice: state?.updateAllSellingPrice,
                loading: true,
            };
        case InboundActionTypes.UPDATE_ALL_SELLING_PRICE_SUCCESS:
            return {
                updateAllSellingPrice: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_ALL_SELLING_PRICE_ERROR:
            return {
                updateAllSellingPrice: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_ALL_SELLING_PRICE_INITIAL_STATE };
        default:
            return state;
    }
};

const updateAllYardsReducer = (state = UPDATE_ALL_YARDS_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_ALL_YARDS_LOADING:
            return {
                updateYards: state?.updateYards,
                loading: true,
            };
        case InboundActionTypes.UPDATE_ALL_YARDS_SUCCESS:
            return {
                updateYards: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_ALL_YARDS_ERROR:
            return {
                updateYards: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_ALL_YARDS_INITIAL_STATE };
        default:
            return state;
    }
};

const updateAllUnitsReducer = (state = UPDATE_ALL_UNITS_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_ALL_UNITS_LOADING:
            return {
                units: state?.units,
                loading: true,
            };
        case InboundActionTypes.UPDATE_ALL_UNITS_SUCCESS:
            return {
                units: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_ALL_UNITS_ERROR:
            return {
                units: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_ALL_UNITS_INITIAL_STATE };
        default:
            return state;
    }
};
const updateSelectedReducer = (state = UPDATE_SELECTED_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_SELECTED_DATA_LOADING:
            return {
                updateSelected: action.payload,
                loading: true,
            };
        case InboundActionTypes.UPDATE_SELECTED_DATA_SUCCESS:
            return {
                updateSelected: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_SELECTED_DATA_ERROR:
            return {
                updateSelected: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_SELECTED_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const updateSelectedDescriptionReducer = (state = UPDATE_DESCRIPTION_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_SELECTED_DESCRIPTION_LOADING:
            return {
                description: action.payload,
                loading: true,
            };
        case InboundActionTypes.UPDATE_SELECTED_DESCRIPTION_SUCCESS:
            return {
                description: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_SELECTED_DESCRIPTION_ERROR:
            return {
                description: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_DESCRIPTION_INITIAL_STATE };
        default:
            return state;
    }
};
const updateAllDescriptionReducer = (state = UPDATE_DESCRIPTION_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_ALL_DESCRIPTION_LOADING:
            return {
                description: action.payload,
                loading: true,
            };
        case InboundActionTypes.UPDATE_ALL_DESCRIPTION_SUCCESS:
            return {
                description: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_ALL_DESCRIPTION_ERROR:
            return {
                description: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_DESCRIPTION_INITIAL_STATE };
        default:
            return state;
    }
};
const updateSelectedUnitReducer = (state = UPDATE_SELECTED_UNIT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_SELECTED_UNIT_DATA_LOADING:
            return {
                updateSelectedUnit: action.payload,
                loading: true,
            };
        case InboundActionTypes.UPDATE_SELECTED_UNIT_DATA_SUCCESS:
            return {
                updateSelectedUnit: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_SELECTED_UNIT_DATA_ERROR:
            return {
                updateSelectedUnit: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_SELECTED_UNIT_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const deleteInboundReducer = (state = DELETE_INBOUND_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.DELETE_INBOUND_DATA_LOADING:
            return {
                deleteInboundData: action.payload,
                loading: true,
            };
        case InboundActionTypes.DELETE_INBOUND_DATA_SUCCESS:
            return {
                deleteInboundData: action.payload,
                loading: false,
            };
        case InboundActionTypes.DELETE_INBOUND_DATA_ERROR:
            return {
                deleteInboundData: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...DELETE_INBOUND_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
// ---------------------------------------------------------------T A G  N O--------------------------------------------------

const tagReducer = (state = GET_TAG_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.TAG_DATA_LOADING:
            return {
                tagNo: state.tagNo,
                loading: true,
            };
        case InboundActionTypes.TAG_DATA_SUCCESS:
            return {
                tagNo: action.payload,
                loading: false,
            };
        case InboundActionTypes.TAG_DATA_ERROR:
            return {
                tagNo: action.payload,
                loading: false,
            };
        case InboundActionTypes.RESET_TAG_DATA:
            return {
                tagNo: [],
                loading: false,
            };
        default:
            return state;
    }
};

const tagDataReducer = (state = GET_TAG_NO_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.TAG_NO_LOADING:
            return {
                tagData: state.tagData,
                loading: true,
            };
        case InboundActionTypes.TAG_NO_SUCCESS:
            return {
                tagData: action.payload,
                loading: false,
            };
        case InboundActionTypes.TAG_NO_ERROR:
            localStorage.setItem('tagNoError', JSON.stringify(action.payload));
            return {
                tagData: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            localStorage.removeItem('tagNoError', JSON.stringify(action.payload));
            return { ...GET_TAG_NO_INITIAL_STATE };
        default:
            return state;
    }
};

const updateInventoryTransactionReducer = (state = UPDATE_TRANSACTION_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_INVENTORY_TRANSACTIONS_DATA_LOADING:
            return {
                updateTransaction: action.payload,
                loading: true,
            };
        case InboundActionTypes.UPDATE_INVENTORY_TRANSACTIONS_DATA_SUCCESS:
            return {
                updateTransaction: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_INVENTORY_TRANSACTIONS_DATA_ERROR:
            return {
                updateTransaction: action.payload,
                // error: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_TRANSACTION_DATA_INITIAL_STATE };
        default:
            return state;
    }
};

const getByTagReducer = (state = GET_BY_TAG_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.GET_DETAILS_BY_TAG_LOADING:
            return {
                getByTag: action.payload,
                loading: true,
            };
        case InboundActionTypes.GET_DETAILS_BY_TAG_SUCCESS:
            return {
                getByTag: action.payload,
                loading: false,
            };
        case InboundActionTypes.GET_DETAILS_BY_TAG_ERROR:
            return {
                getByTag: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...GET_BY_TAG_INITIAL_STATE };
        default:
            return state;
    }
};

const getByDocReducer = (state = GET_BY_DOC_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.GET_BY_DOC_LOADING:
            return {
                getByDoc: action.payload,
                loading: true,
            };
        case InboundActionTypes.GET_BY_DOC_SUCCESS:
            return {
                getByDoc: action.payload,
                loading: false,
            };
        case InboundActionTypes.GET_BY_DOC_ERROR:
            return {
                getByDoc: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...GET_BY_DOC_INITIAL_STATE };
        default:
            return state;
    }
};

const getPrintContentReducer = (state = GET_PRINT_CONTENT_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.GET_PRINT_CONTENT_LOADING:
            return {
                getPrintContent: action.payload,
                loading: true,
            };
        case InboundActionTypes.GET_PRINT_CONTENT_SUCCESS:
            return {
                getPrintContent: action.payload,
                loading: false,
            };
        case InboundActionTypes.GET_PRINT_CONTENT_ERROR:
            return {
                getPrintContent: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...GET_PRINT_CONTENT_INITIAL_STATE };
        default:
            return state;
    }
};

const getExcelContentReducer = (state = GET_EXCEL_CONTENT_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.GET_EXCEL_CONTENT_LOADING:
            return {
                getExcelContent: action.payload,
                loading: true,
            };
        case InboundActionTypes.GET_EXCEL_CONTENT_SUCCESS:
            return {
                getExcelContent: action.payload,
                loading: false,
            };
        case InboundActionTypes.GET_EXCEL_CONTENT_ERROR:
            return {
                getExcelContent: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return {
                getExcelContent: [],
                loading: false,
            };
        default:
            return state;
    }
};

const updateTagByStatusReducer = (state = UPDATE_TAG_BY_STATUS_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.UPDATE_TAG_BY_STATUS_LOADING:
            return {
                tagByStatus: action.payload,
                loading: true,
            };
        case InboundActionTypes.UPDATE_TAG_BY_STATUS_SUCCESS:
            return {
                tagByStatus: action.payload,
                loading: false,
            };
        case InboundActionTypes.UPDATE_TAG_BY_STATUS_ERROR:
            return {
                tagByStatus: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_TAG_BY_STATUS_INITIAL_STATE };
        default:
            return state;
    }
};

const getInvoiceDataReducer = (state = GET_INVOICE_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.GET_INVOICE_DATA_LOADING:
            return {
                invoiceData: action.payload,
                loading: true,
            };
        case InboundActionTypes.GET_INVOICE_DATA_SUCCESS:
            return {
                invoiceData: action.payload,
                loading: false,
            };
        case InboundActionTypes.GET_INVOICE_DATA_ERROR:
            return {
                invoiceData: action.payload,
                // error: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return {
                invoiceData: [],
                loading: false,
            };;
        default:
            return state;
    }
};

const getReceiverDataReducer = (state = GET_RECEIVER_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case InboundActionTypes.GET_RECEIVER_DATA_LOADING:
            return {
                receiverData: action.payload,
                loading: true,
            };
        case InboundActionTypes.GET_RECEIVER_DATA_SUCCESS:
            return {
                receiverData: action.payload,
                loading: false,
            };
        case InboundActionTypes.GET_RECEIVER_DATA_ERROR:
            return {
                receiverData: action.payload,
                loading: false,
            };
        case InboundActionTypes.STATE_EMPTY_FIRST:
            return {
                receiverData: [],
                loading: false,
            };
        default:
            return state;
    }
};
export {
    inboundReducer,
    getEditInboundReducer,
    createInboundReducer,
    uploadInboundReducer,
    updateInboundReducer,
    deleteInboundReducer,
    tagReducer,
    tagDataReducer,
    updateAllReducer,
    updateAllYardsReducer,
    updateSelectedReducer,
    updateSelectedUnitReducer,
    updateInventoryTransactionReducer,
    getByTagReducer,
    getByDocReducer,
    getPrintContentReducer,
    getExcelContentReducer,
    updateTagByStatusReducer,
    updateAllSellingPriceReducer,
    updateSelectedDescriptionReducer,
    updateAllDescriptionReducer,
    getInvoiceDataReducer,
    getReceiverDataReducer,
    updateAllUnitsReducer
};
